import React, { useMemo } from 'react';
import Authenticated from '@/Layouts/Authenticated';
import { Head, Link } from '@inertiajs/inertia-react';
import _date from '@/helpers/date';
import numberFormat from '@/helpers/numberFormat';
import OrderCard from '@/Components/SalesDaily/OrderCard';
import Button from '@/Components/Button';
const { DateTime } = require("luxon");
import { hasRole } from '@/helpers/user'

export default function SalesDaily({ auth, errors, date, office, store, orders, products, orderTypes, ...props}) {
    const dateObj = DateTime.fromISO(date);
    const title = `Resumen de ventas diarias: ${dateObj.toLocaleString(DateTime.DATE_FULL) }`

    const ordersTotalProductsPrice = useMemo(() => orders.reduce((acc, order) => {
        return acc + order.parsed.totals.products_total;
    }, 0), [orders]);

    const Header = () =>
        <div className='flex justify-between gap-2'>
            <h2 className="font-semibold text-lg sm:text-xl text-gray-800 leading-tight">
                {title}
            </h2>
            <a href="#" className="cursor-pointer" onClick={(event) => {
                event.preventDefault();
                window.history.back();
            }}>
                ← Volver
            </a>
        </div>

    const [totalTickets, totalPrice] = orders.reduce((acc, order) => {
        const tickets_number = order.parsed.tickets_number;
        return [
            acc[0] + tickets_number,
            acc[1] + order.parsed.totals.total,
        ];
    }, [0, 0]);

    const [totalTicketsIva, totalPriceIva] = orders.reduce((acc, order) => {
        const tickets_number = order.parsed.tickets_number;
        return [
            acc[0] + tickets_number,
            acc[1] + order.parsed.totals_iva.total,
        ];
    }, [0, 0]);
    console.log({date: DateTime.fromISO(date).startOf('day').toISODate()})

    return (
        <Authenticated
            branchOffice={office}
            store={store}
            auth={auth}
            errors={errors}
            header={<Header/>}
        >
            <Head title={title} />


            <div className="py-12 max-w-7xl px-4 sm:px-6 lg:px-8 mx-auto flex flex-col gap-10">

                <div className="flex justify-end items-center gap-4">
                    <div className="flex justify-end items-center">
                        <a target="_blank" href={route('export.sales-daily.loading', { date: DateTime.fromISO(date).startOf('day').toISODate(), branchOffice: office.id })}>
                            <Button type="button">Exportar en PDF</Button>
                        </a>
                    </div>

                    {hasRole(auth.user, 'super_admin') && (
                        <div className="flex justify-end items-center">
                            <a target="_blank" href={route('export.sales-daily.excel', { date: DateTime.fromISO(date).startOf('day').toISODate(), branchOffice: office.id })}>
                                <Button type="button">Exportar en Excel</Button>
                            </a>
                        </div>
                    )}
                </div>

                {[
                    {
                        title: 'Ventas por Mercado Pago',
                        type: 'mercadopago',
                    },
                    {
                        title: 'Ventas Redelcom',
                        type: 'redelcom',
                    },
                    {
                        title: 'Ventas Efectivo',
                        type: 'manual',
                    },
                    {
                        title: 'Ventas Empresa',
                        type: 'bulk',
                    },
                    {
                        title: 'Venta de productos Redelcom',
                        type: 'product-redelcom'
                    },
                    {
                        title: 'Venta de productos Efectivo',
                        type: 'product-manual'
                    },
                ].map(({ title, type }, index) => (
                    <OrderCard
                        key={`order-card-item-${type}-${index}`}
                        title={title}
                        office={office}
                        products={products}
                        types={orderTypes}
                        type={type}
                        orders={orders}
                        store={store}
                    />
                ))}

                <div className='px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg'>
                    <div className="flex items-center justify-between gap-4 mb-2">
                        <h2 className='text-gray-900 text-lg font-bold'>Total del día</h2>
                        <h2 className='text-gray-900 text-lg font-bold'></h2>
                        <h2 className='text-gray-900 text-lg font-bold'></h2>
                        <h2 className='text-gray-900 text-lg'>
                            <div className="grid grid-cols-2 gap-3">
                                <div>Total s/ IVA: </div>
                                <div>${numberFormat(totalPrice, 0, '', '.')}</div>
                            </div>
                            <div className="grid grid-cols-2 gap-3">
                                <div>Impuesto: </div>
                                <div>${numberFormat(totalPriceIva - totalPrice, 0, '', '.')}</div>
                            </div>
                            <div className="grid grid-cols-2 gap-3 font-bold">
                                <div>Total c/ IVA:</div>
                                <div>${numberFormat(totalPriceIva, 0, '', '.')}</div>
                            </div>
                        </h2>
                    </div>
                </div>
            </div>

            <div className='pb-12 max-w-7xl mx-auto sm:px-6 lg:px-8 flex justify-between px-4'>
                <Link
                    className='px-4 py-2 bg-gray-900 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest active:bg-gray-900 transition ease-in-out duration-150'
                    href={route('order.daily', {office:office.slug, 'date': dateObj.plus({days: -1}).toISODate() })}
                >
                    Anterior
                </Link>
                <Link
                    className='px-4 py-2 bg-gray-900 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest active:bg-gray-900 transition ease-in-out duration-150'
                    href={route('order.daily', {office:office.slug, 'date': dateObj.plus({days: 1}).toISODate() })}
                >
                    Siguiente
                </Link>
            </div>
        </Authenticated>
    );
}
